'use client';

import { forwardRef } from 'react';

interface BerryClusterProps {
  className?: string;
  /** 0–1 draw progress for the loader stroke animation (unused, kept for API compat) */
  drawProgress?: number;
  color?: string;
  /** Color shown through the calyx centers — match the surface behind the mark */
  surface?: string;
  strokeWidth?: number;
}

const BerryCluster = forwardRef<SVGSVGElement, BerryClusterProps>(
  ({ className = '', color = '#ffffff', surface = '#6D28D9', strokeWidth = 3.5 }, ref) => {
    return (
      <svg
        ref={ref}
        viewBox="0 0 220 220"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="Blueberries logo"
      >
        {/* Berry circles */}
        <circle cx="136" cy="70" r="44" stroke={color} strokeWidth={strokeWidth} fill="none" />
        <circle cx="72" cy="116" r="44" stroke={color} strokeWidth={strokeWidth} fill="none" />
        <circle cx="148" cy="154" r="37" stroke={color} strokeWidth={strokeWidth} fill="none" />

        {/* Leaves */}
        <path
          d="M155,38 C163,22 185,16 194,23 C191,37 173,46 160,44 C156,43 153,41 155,38 Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
          fill="none"
        />
        <path d="M155,38 C170,30 182,21 194,23" stroke={color} strokeWidth={strokeWidth * 0.5} opacity="0.5" fill="none" />
        <path
          d="M163,126 C171,112 191,108 199,117 C196,130 177,138 165,135 C160,134 161,129 163,126 Z"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
          fill="none"
        />
        <path d="M163,126 C175,121 187,112 199,117" stroke={color} strokeWidth={strokeWidth * 0.5} opacity="0.5" fill="none" />

        {/* Calyx crowns */}
        <g>
          <path
            d="M132,63.1 C130.3,48.8 141.7,48.8 140,63.1 C151.6,54.4 157.3,64.3 144,70 C157.3,75.7 151.6,85.6 140,76.9 C141.7,91.3 130.3,91.3 132,76.9 C120.4,85.6 114.8,75.7 128,70 C114.8,64.3 120.4,54.4 132,63.1 Z"
            fill={color}
          />
          <circle cx="136" cy="70" r="5" fill={surface} />
          <circle cx="136" cy="70" r="2.5" fill={color} />
        </g>
        <g>
          <path
            d="M68,109.1 C66.3,94.8 77.7,94.8 76,109.1 C87.6,100.4 93.3,110.3 80,116 C93.3,121.7 87.6,131.6 76,122.9 C77.7,137.3 66.3,137.3 68,122.9 C56.4,131.6 50.8,121.7 64,116 C50.8,110.3 56.4,100.4 68,109.1 Z"
            fill={color}
          />
          <circle cx="72" cy="116" r="5" fill={surface} />
          <circle cx="72" cy="116" r="2.5" fill={color} />
        </g>
        <g>
          <path
            d="M144.6,148.2 C143.2,136.1 152.8,136.1 151.4,148.2 C161.1,140.9 165.9,149.2 154.7,154 C165.9,158.8 161.1,167.1 151.4,159.8 C152.8,171.9 143.2,171.9 144.6,159.8 C134.9,167.1 130.1,158.8 141.3,154 C130.1,149.2 134.9,140.9 144.6,148.2 Z"
            fill={color}
          />
          <circle cx="148" cy="154" r="4.2" fill={surface} />
          <circle cx="148" cy="154" r="2.1" fill={color} />
        </g>
      </svg>
    );
  }
);

BerryCluster.displayName = 'BerryCluster';
export default BerryCluster;
